import React from 'react';
import classnames from 'classnames/bind';
import { ChatAgentSidebarCloseButton } from '../ChatAgentSidebarCloseButton/ChatAgentSidebarCloseButton';
import styles from './chatContainer.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ChatContainer = ({ isHidden, closeChat, HeaderTitle, children, testIdPrefix }) => {
    return (
        <div className={classNameBuilder('container', { hidden: isHidden })}>
            <div className={styles['header']} data-testid={`${testIdPrefix}-header`}>
                {HeaderTitle}
                <div className={styles['action-buttons-container']}>
                    <ChatAgentSidebarCloseButton closeChat={closeChat} testIdPrefix={testIdPrefix} />
                </div>
            </div>

            <div className={styles['chat-container']} data-testid={`${testIdPrefix}-container`}>
                {children}
            </div>
        </div>
    );
};
